import { Button } from '@hivebrite/design-system/Button';
import {
  FontAwesomeIcon,
  CATEGORIES,
} from '@hivebrite/design-system/FontAwesomeIcon';

import { RegistrationSteps } from 'hb-react/shared/apps/Events/constants/registrationSteps';
import { useRegistrationFlowContext } from 'hb-react/shared/apps/Events/contexts/RegistrationFlowContext';

const ArrowLeftIcon = () => (
  <FontAwesomeIcon
    iconName="chevron-left"
    height="16px"
    iconType={CATEGORIES.SOLID}
  />
);

const BackButton = ({ isFixed, values }) => {
  const { updateRegistrationFlow, setValuesStep3 } =
    useRegistrationFlowContext();

  const goBack = () => {
    setValuesStep3(values);
    updateRegistrationFlow({
      currentStep: RegistrationSteps.TICKET_INFORMATION_STEP,
    });
  };

  return (
    <Button
      onClick={() => goBack()}
      variant="secondary"
      icon={!isFixed && ArrowLeftIcon}
    >
      {isFixed
        ? s__('NetworkEvents|Back')
        : s__('NetworkEvents|Go back to Registration')}
    </Button>
  );
};

export default BackButton;
